import { Role, RoleInfo } from "../Enums/Role";
import { type UserRoles } from "./type";

const ADMIN = RoleInfo[Role.ADMIN].name;
const MANAGER = RoleInfo[Role.MANAGER].name;
const SUPERVISOR = RoleInfo[Role.SUPERVISOR].name;
const ACCOUNTANT = RoleInfo[Role.ACCOUNTANT].name;
const CASHIER = RoleInfo[Role.CASHIER].name;
const SALES_PERSON = RoleInfo[Role.SALES_PERSON].name;

const ROLES = [ADMIN, MANAGER, ACCOUNTANT, SUPERVISOR, CASHIER, SALES_PERSON] as const;

export const STANDARD_ROLES = ROLES;

export const ROLE_HIERARCHY: Record<string, number> = {
  [ADMIN]: 100,
  [MANAGER]: 80,
  [ACCOUNTANT]: 70,
  [SUPERVISOR]: 60,
  [CASHIER]: 50,
  [SALES_PERSON]: 30,
};

export const MANAGEABLE_ROLES: Record<string, readonly string[]> = {
  [ADMIN]: [ADMIN, MANAGER, ACCOUNTANT, SUPERVISOR, CASHIER, SALES_PERSON],
  [MANAGER]: [CASHIER, SUPERVISOR, SALES_PERSON, ACCOUNTANT],
  [SUPERVISOR]: [CASHIER, SALES_PERSON],
  [ACCOUNTANT]: [],
  [CASHIER]: [],
  [SALES_PERSON]: [],
};

export const getRoleHierarchyLevel = (role: string): number =>
  ROLE_HIERARCHY[role] ?? 0;

export const canManageRole = (
  currentRole: string,
  targetRole: string,
): boolean => {
  const manageable = MANAGEABLE_ROLES[currentRole];
  if (!manageable) return false;
  return manageable.includes(targetRole);
};

export const hasHigherOrEqualHierarchy = (
  currentRole: string,
  targetRole: string,
): boolean => {
  return (
    getRoleHierarchyLevel(currentRole) >= getRoleHierarchyLevel(targetRole)
  );
};
